<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="950px" :before-close="handleClose"  :close-on-click-modal="false">
      <div>
        <el-form label-width="180px">
          <el-row>
            <el-form-item label="市场：">
              白糖
            </el-form-item>
            <el-form-item label="银行渠道：">
              白糖-中信银行
            </el-form-item>
            <el-form-item label="附属账号：">
              {{sugerDetail.subBankAccount}}
            </el-form-item>
            <el-form-item label="附属账户名：">
              {{sugerDetail.subBankAccountName}}
            </el-form-item>
            <el-form-item label="附属账户金额：" v-if="payWay === '1'">
              {{canUseBalance | thousandMark}}
            </el-form-item>
            <el-form-item label="入金金额：" v-if="payWay === '1'">
              <el-input v-model="amount" style="width: 200px" placeholder="请输入金额" @input="checkType"></el-input>
            </el-form-item>
            <el-form-item label="出金金额：" v-if="payWay === '0'">
              <el-input v-model="amount" style="width: 200px" placeholder="请输入金额" @input="checkType"></el-input>
            </el-form-item>
            <el-form-item label="支付密码：">
              <el-input v-model='payPwd' :type="isDesen ? 'password' : ''" placeholder='输入6位数字' class="input" @input="checkPass(payPwd, 'payPwd')"></el-input>
              <div @click="select" class="tips">
                <img src="@/assets/password_hide.png" alt="" class="password" v-if="isDesen">
                <img src="@/assets/password_visual.png" alt="" class="password" v-if="!isDesen">
              </div>
            </el-form-item>
            <span class="forget-password" @click="forgetPassword">
              忘记密码
            </span>
          </el-row>
          <el-table ref="zTable" border :data="tableData" class="table" v-if="payWay === '0'" style="width: 700px;">
            <el-table-column prop="currentBalance" label="诚意金余额（元）" align="center"></el-table-column>
            <el-table-column prop="canGetBalance" label="可预支诚意金（元）" align="center"></el-table-column>
            <el-table-column prop="fundOutBalanceSum" label="当日诚意金划出总额（元）" align="center"></el-table-column>
            <el-table-column prop="fundOutCount" label="当日诚意金划出次数" align="center"></el-table-column>
          </el-table>
        </el-form>
      </div>
      <div class="text-c m-t-20">
        <el-button size="small" @click="handleClose">返 回</el-button>
        <el-button size="small" class='sure' type="primary" @click="sure" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <forget-pass @closeMain="closeMain" v-if="isDisplay" editType='2'></forget-pass>
    <set-pass @closeMain="closeMain" v-if="isSetDisplay" :userId="userId"></set-pass>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
// import CryptoJS from 'crypto-js'
import api from '@/api'
import forgetPass from '@/components/forget-pass'
import setPass from '@/components/set-pass'
import { filterDecAmount } from '@/utils/util'
export default {
  // 出金 0 入金 1
  name: 'cji-access',
  props: {
    payWayType: {
      type: String
    },
    title: {
      title: String
    }
  },
  components: {
    forgetPass,
    setPass
  },
  data () {
    return {
      loading: false,
      isDisplay: false,
      isSetDisplay: false,
      // 密码
      passwordReg: /^\d{6}$/,
      dialogVisible: true,
      sugerDetail: {},
      payWay: '1',
      accountList: [],
      amount: '',
      payPwd: '',
      // 密码脱敏显示
      isDesen: true,

      // 屏蔽快速点击
      btnOff: true,

      restaurants: [],
      timeout: null,

      tableData: [],
      canUseBalance: '',

      // 用户id
      userId: Cookie.getJSON('AppUserInfo').userId,

      // 前端校验
      createRules: [
        { name: 'amount', message: '请输入金额' },
        { name: 'payPwd', message: '请输入支付密码' }
      ],
    }
  },
  watch: {
    'amount': function () {
      if (this.btnOff) {
        this.btnOff = false
        this.amount = ''
      }
    }
  },
  created () {
    this.payWay = this.payWayType
    this.querySubBankAccountInfo()
  },
  methods: {
    // 密码脱敏显示
    select () {
      this.isDesen = !this.isDesen
    },
    // 忘记密码
    forgetPassword () {
      this.isDisplay = true
    },
    // 关闭弹窗
    closeMain (e) {
      this.isDisplay = false
      this.isSetDisplay = false
    },
    // 判断是否是数字
    checkPass (v, k) {
      if (!isNaN(v)) {
        this[k] = v
      } else {
        this[k] = ''
      }
    },
    // 金额校验
    checkType (v) {
      this.amount = filterDecAmount(v)
    },
    // 查询银行附属账户信息 0
    querySubBankAccountInfo () {
      api.myAccount.querySubBankAccountInfo().then((res) => {
        if (res.succeed) {
          this.sugerDetail = res.data
          if (this.payWay === '0') {
            this.fundInInit(this.sugerDetail)
          }
          if (this.payWay === '1') {
            this.querySubBankAccountBalance(this.sugerDetail)
          }
        } else {
          this.$message.error('附属账户查询失败')
        }
      })
    },
    // 查询银行附属账户余额 0
    querySubBankAccountBalance (sugerDetail) {
      api.myAccount.querySubBankAccountBalance({
        bankProCode: sugerDetail.bankProCode,
        subBankAccount: sugerDetail.subBankAccount
      }).then((res) => {
        if (res.succeed) {
          this.canUseBalance = res.data.canUseBalance
        } else {
          this.$message.error('附属账户余额查询失败')
        }
      })
    },
    // 结算账号查询 1
    fundInInit () {
      api.myAccount.fundInInit().then((res) => {
        if (res.succeed) {
          // 查询银行附属账户余额 0
          api.myAccount.querySettleAccountMoney({
            settlementAccount: res.data.settlementAccount
          }).then((res) => {
            if (res.succeed) {
              this.tableData = [res.data]
            } else {
              this.$message.error('附属账户余额查询失败')
            }
          }).catch((err) => {
            this.$message.error(err)
          })
        } else {
          this.$message.error('附属账户查询失败')
        }
      })
    },
    // 确定
    async sure () {
      let param = {
        marketId: '000',
        amount: this.amount,
        payPwd: this.payPwd
      }
      if (this.payWay === '0' && this.canUseBalance > this.tableData[0].canGetBalance) {
        this.$message.error('转出金额不能大于可预支金额')
        return
      }
      if (this.$utils.checkEmptyRules(param, this.createRules)) {
        return
      }
      this.loading = true
      let accountFund = null
      if (this.payWay === '0') {
        accountFund = api.myAccount.outAccountFund
      }
      if (this.payWay === '1') {
        accountFund = api.myAccount.intoAccountFund
      }
      const data = (await api.myAccount.checkHasPsw({ userId: this.userId })).data
      // 已经设置了支付密码
      if (data === '1') {
        accountFund(param).then((res) => {
          if (res.succeed) {
            this.loading = false
            this.$message.success('成功')
          } else {
            this.$message.error('失败')
          }
          this.$emit('done')
        }).catch((err) => {
          this.loading = false
          this.$message.error(err)
        })
      }
      // 没有设置支付密码
      if (data === '0') {
        this.$confirm('您还没有设置支付密码, 是否设置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isSetDisplay = true
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消设置'
          })
        })
      }
    },
    handleClose () {
      this.$emit('done')
    }
  },
}
</script>

<style lang="scss" scoped>
.input {
  width: 200px;
  height: 30px;
  line-height: 30px;
}
.password {
  width: 22px;
  height: 10px;
  float: left;
}
.tips {
  position: absolute;
  top: 16px;
  left: 170px;
  width: 25px;
  height: 25px;
}
.gobal-form{
  .el-input, .el-input__inner{
    width:217px !important;
  }
  div.input-val{
    display:inline-block;
    width:217px;
  }
}
.forget-password{
  cursor: pointer;
  color: blue;
  text-decoration: underline;
  font-size: 12px;
  margin-left: 180px;
}
.next {
  margin: 0 0 0 150px;
}
.sure {
  margin-left: 30px;
}
.recvAccNo {
  display: block;
  margin-left: -38px;
  width: 235px;
}
.recvAccNo li {
  list-style: none;
  border: 1px solid red;
  text-align: left;
  height: 30px;
  line-height: 30px;
}
.table {
  margin: 20px 0 0 100px;
}
</style>
